


























































































































































































import { Component, Watch, Prop } from "vue-property-decorator";
import { ChatConfiguration } from "./chatConfiguration";

import WidgetBase from "../WidgetBase.vue";
import { ParticipantInfo } from "../../../interfaces/user";
import { SocketService } from "../../../services/socketService";
import { Message } from "../../../interfaces/chat";

@Component
export default class ChatWidget extends WidgetBase<ChatConfiguration> {
    @Prop() widgetHeight!: number;

    public static get type() {
        return "chat";
    }

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/chat.svg");
    }
    public text: string = "";
    public selectedChat: number | null = null;
    public activeParticipant?: ParticipantInfo;

    public participants: ParticipantInfo[] = [];

    public get sortedParticipants(): ParticipantInfo[] {
        return this.participants.sort(
            (a: ParticipantInfo, b: ParticipantInfo) => {
                const aUnanswered = this.chatUnanswered(a.id) ? -1 : 0;
                const bUnanswered = this.chatUnanswered(b.id) ? -1 : 0;

                if (aUnanswered !== bUnanswered) {
                    return aUnanswered - bUnanswered;
                }

                return this.chatLength(b.id) - this.chatLength(a.id);
            }
        );
    }

    public get groupMessages(): Message[] {
        return this.config.state.group.messages || [];
    }

    public get privateMessages(): Message[] {
        this.scroller();
        return this.config.state.private.messages || [];
    }

    public mounted() {
        this.participantWatcher();
        this.scroller();
        if (this.isPresenter && this.config.state.private.participants) {
            this.participants = this.config.state.private.participants;
        }
    }

    public get groupModeActive(): boolean {
        return this.config.state.groupModeActive;
    }
    public set groupModeActive(newValue: boolean) {
        this.config.state.groupModeActive = newValue;
        this.activeParticipant = undefined;
        this.update({
            config: this.config,
            payload: { groupModeActive: newValue },
        });
    }

    public mouseOverParticipants: boolean = false;

    public get cols(): { chat: number; participants: number } {
        let chat: number = 12;
        if (
            !this.groupModeActive &&
            (this.isPresenter || this.isPromotedUser)
        ) {
            chat = 8;
        }
        if (this.mouseOverParticipants) {
            chat = 4;
        }
        return { chat: chat, participants: 12 - chat };
    }

    public get promotedUsers(): string[] {
        return this.config.state.promoted;
    }
    @Watch("config.state.private.activeParticipants")
    public participantsForPromotedUsers() {
        if (this.isPromotedUser) {
            this.participants = this.filterParticipants(
                this.config.state.private.activeParticipants
            );
        }
    }

    public chatLength(chatId: string): number {
        return this.privateMessages.filter(message => {
            return message.fromUserId == chatId || message.toUserId == chatId;
        }).length;
    }

    public chatUnanswered(chatId: string): boolean {
        const chat: Message[] = this.privateMessages.filter(message => {
            return message.fromUserId == chatId || message.toUserId == chatId;
        });
        if (chat.length == 0) {
            return false;
        }
        return chat[chat.length - 1].fromUserId == chatId;
    }

    @Watch("$store.state.participantInfo")
    public participantInfoChanged() {
        // only unique participants, not self
        this.participants = this.filterParticipants(
            this.$store.state.participantInfo as ParticipantInfo[]
        );
        this.update({
            config: this.config,
            payload: { participants: this.participants },
        });
    }

    public filterParticipants(participants: ParticipantInfo[]) {
        return participants
            .filter(
                (v: ParticipantInfo, i: number, a: ParticipantInfo[]) =>
                    a.findIndex((t: ParticipantInfo) => t.id === v.id) === i
            )
            .filter((p: ParticipantInfo) => p.id != this.$store.state.user.id);
    }

    @Watch("$store.state.studio.attributes.participants")
    public participantWatcher() {
        if (this.isPromotedUser) return;
        if (this.isPresenter && this.$store.state.studio) {
            SocketService.participantInfoRequest(
                this.$store.state.studio.studioId
            );
        }
    }

    public promote(item: ParticipantInfo) {
        this.update({ config: this.config, payload: { promotion: item } });
    }

    public selectChat(item: ParticipantInfo) {
        this.activeParticipant = item;
        (this.$refs.textfield as HTMLInputElement).focus();
    }

    public get isPromotedUser(): boolean {
        return this.promotedUsers?.includes(this.$store.state.user.id) || false;
    }

    @Watch("isPromotedUser")
    public promotionWatcher(newvalue: boolean) {
        if (newvalue === false) {
            this.activeParticipant = undefined;
        }
    }

    public get isPresenter(): boolean {
        return this.$store.getters.isPresenter;
    }

    public textareaContent(): Message[] {
        if (this.groupModeActive) return this.groupMessages;

        if (
            (this.isPresenter || this.isPromotedUser) &&
            this.activeParticipant
        ) {
            // messages from and to selected participant
            return this.privateMessages.filter(
                mes =>
                    mes.toUserId == this.activeParticipant?.id ||
                    (mes.toUserId == "presenter" &&
                        mes.fromUserId == this.activeParticipant?.id)
            );
        }
        // messages from or to user (guest)
        return this.privateMessages.filter(
            mes =>
                mes.fromUserId == this.$store.state.user.id ||
                mes.toUserId == this.$store.state.user.id
        );
    }

    public scroller() {
        this.$nextTick(() => {
            const textarea = this.$refs.textarea as HTMLDivElement;
            textarea.scrollTop = textarea?.scrollHeight;
        });
    }

    public send() {
        let payload: Message;
        if (this.text == "") {
            return;
        }
        if (!this.groupModeActive && this.activeParticipant) {
            payload = {
                author: this.$store.state.user.displayname,
                message: this.text,
                toWebsocket: this.activeParticipant.websocketId,
                toUserId: this.activeParticipant.id,
                toEmail: this.activeParticipant.email,
                fromUserId: this.$store.state.user.id,
            };
            // for local view
            this.privateMessages.push(payload);
        } else {
            payload = {
                author: this.$store.state.user.displayname,
                message: this.text,
                toWebsocket: this.$store.state.studio?.studioId || "",
                toUserId: "presenter",
            };
        }
        this.update({ config: this.config, payload });
        this.text = "";
    }
}
